import apiProxy from "@shared/utils/api-proxy";
import { type ErrorLogDetailsRequest } from "@shared/types/common";
import { useAuthStore } from "@shared/stores/auth.ts";
import { useSubscriptionsStore } from "@shared/stores/subscriptions.ts";

export const remoteErrorLogger = {
  logError: async (message: string) => {
    const userEmail = useAuthStore().user?.email;
    const subscriptionNumber =
      useSubscriptionsStore().currentSubscriptionNumberInt;
    const request: ErrorLogDetailsRequest = {
      message,
      userEmail,
      subscriptionNumber,
    };
    try {
      await apiProxy.post(`error-logger`, request);
    } catch (e) {
      console.warn("Error logging error", e);
      return;
    }
  },
};
